var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Socruithe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94056944,1.60747167 C9.46052611,-0.535823889 12.5094739,-0.535823889 13.0294306,1.60747167 C13.1876671,2.26054115 13.6482934,2.79876348 14.2690897,3.05596086 C14.889886,3.31315824 15.596187,3.25839665 16.16992,2.90858389 C18.0532372,1.76126167 20.2099589,3.91676278 19.0626367,5.80130056 C18.7133289,6.37478334 18.6586994,7.08054173 18.9155939,7.70094779 C19.1724883,8.32135386 19.7100545,8.78189904 20.3625283,8.94056944 C22.5058239,9.46052611 22.5058239,12.5094739 20.3625283,13.0294306 C19.7094589,13.1876671 19.1712365,13.6482934 18.9140391,14.2690897 C18.6568418,14.889886 18.7116034,15.596187 19.0614161,16.16992 C20.2087383,18.0532372 18.0532372,20.2099589 16.1686994,19.0626367 C15.5952167,18.7133289 14.8894583,18.6586994 14.2690522,18.9155939 C13.6486461,19.1724883 13.188101,19.7100545 13.0294306,20.3625283 C12.5094739,22.5058239 9.46052611,22.5058239 8.94056944,20.3625283 C8.78233291,19.7094589 8.3217066,19.1712365 7.70091029,18.9140391 C7.08011398,18.6568418 6.37381302,18.7116034 5.80008,19.0614161 C3.91676278,20.2087383 1.76004111,18.0532372 2.90736333,16.1686994 C3.25667111,15.5952167 3.31130057,14.8894583 3.05440614,14.2690522 C2.79751172,13.6486461 2.25994552,13.188101 1.60747167,13.0294306 C-0.535823889,12.5094739 -0.535823889,9.46052611 1.60747167,8.94056944 C2.26054115,8.78233291 2.79876348,8.3217066 3.05596086,7.70091029 C3.31315824,7.08011398 3.25839665,6.37381302 2.90858389,5.80008 C1.76126167,3.91676278 3.91676278,1.76004111 5.80130056,2.90736333 C7.01697389,3.64946111 8.60369611,2.99280222 8.94056944,1.60747167 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6466667,10.985 C14.6466667,13.0072827 13.0072827,14.6466667 10.985,14.6466667 C8.96271734,14.6466667 7.32333333,13.0072827 7.32333333,10.985 C7.32333333,8.96271734 8.96271734,7.32333333 10.985,7.32333333 C13.0072827,7.32333333 14.6466667,8.96271734 14.6466667,10.985 L14.6466667,10.985 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.881575e1bb71d3cb0247e41760ba3323.svg";
export { ForwardRef as ReactComponent };